<template>
  <div>
    <vs-alert
      v-if="$validator.errors.all().length > 0"
      color="danger"
      title="Atenção!!"
      active="true"
      class="my-3"
      style="height: auto !important"
    >
      <ul>
        <li
          class="mb-2"
          v-for="error in $validator.errors.all()"
          :key="error.id"
        >
          {{ error }}
        </li>
      </ul>
    </vs-alert>
    <form ref="form" role="form" @submit.stop.prevent="onSubmit">
      <div class="con-vs-tabs vs-tabs vs-tabs-primary vs-tabs-position-top">
        <div class="con-ul-tabs">
          <ul class="ul-tabs vs-tabs--ul ul-tabs-left">
            <li class="vs-tabs--li" :class="passo == 0 ? 'activeChild' : ''">
              <button @click="passo = 0" type="button" class="vs-tabs--btn">
                <!----><span>Dados Gerais</span></button
              ><!---->
            </li>
            <li
              v-if="!formCadastro.isGalaxyPay"
              class="vs-tabs--li"
              :class="passo == 1 ? 'activeChild' : ''"
            >
              <button @click="passo = 1" type="button" class="vs-tabs--btn">
                <!----><span>Dados de Remessa</span></button
              ><!---->
            </li>
            <li
              v-if="!formCadastro.isGalaxyPay"
              class="vs-tabs--li"
              :class="passo == 2 ? 'activeChild' : ''"
            >
              <button @click="passo = 2" type="button" class="vs-tabs--btn">
                <!----><span>Dados do Beneficiário</span></button
              ><!---->
            </li>
            <li
              v-if="!formCadastro.isGalaxyPay"
              class="vs-tabs--li"
              :class="passo == 3 ? 'activeChild' : ''"
            >
              <button @click="passo = 3" type="button" class="vs-tabs--btn">
                <!----><span>Dados do Nosso Número</span></button
              ><!---->
            </li>
            <li
              v-if="!formCadastro.isGalaxyPay"
              class="vs-tabs--li"
              :class="passo == 4 ? 'activeChild' : ''"
            >
              <button @click="passo = 4" type="button" class="vs-tabs--btn">
                <!----><span>Dados do Boleto</span></button
              ><!---->
            </li>
            <li
              v-if="formCadastro.isGalaxyPay"
              class="vs-tabs--li"
              :class="passo == 5 ? 'activeChild' : ''"
            >
              <button @click="passo = 5" type="button" class="vs-tabs--btn">
                <!----><span>Dados Pay</span></button
              ><!---->
            </li>
            <li class="vs-tabs--li" :class="passo == 6 ? 'activeChild' : ''">
              <button @click="passo = 6" type="button" class="vs-tabs--btn">
                <!----><span>Formas de Pagamento</span></button
              ><!---->
            </li>
          </ul>
        </div>
      </div>
      <div :class="passo == 0 ? 'div-show' : 'div-hide'">
        <div class="vx-row">
          <div class="vx-col mb-4 mt-4">
            <span>Essa é uma Carteira Galax Pay?</span>
            <vs-switch
              color="success"
              v-model="formCadastro.isGalaxyPay"
              style="width: 60px"
              @input="selecionaIsGalaxyPay()"
            >
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full mb-3">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Nome Carteira"
              name="Nome Carteira"
              id="Nome Carteira"
              :disabled="blockName"
              v-model="formCadastro.nomeCarteira"
              v-validate="{ required: true, min: 6 }"
              :state="validateState('Nome Carteira')"
              :class="validateClass('Nome Carteira')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>
        <div v-if="!formCadastro.isGalaxyPay" class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full mb-3">
            <vs-select
              v-if="contas"
              v-model="formCadastro.idConta"
              id="Conta"
              label="Conta"
              class="select-large w-full"
              name="Conta"
              v-validate="{ required: true }"
              :state="validateState('Conta')"
              :class="validateClass('Conta')"
              @input="selecionaConta()"
            >
              <vs-select-item :key="0" :value="null" :text="'Selecione'" />
              <vs-select-item
                :key="index + 1"
                :value="item.id"
                :text="`${item.label} - ${item.outPutLabel.label} (AG${item.agencia} / CC ${item.conta}-${item.digitoConta})`"
                v-for="(item, index) in contas"
              />
            </vs-select>
          </div>
        </div>
      </div>
      <div
        v-if="!formCadastro.isGalaxyPay"
        :class="passo == 1 ? 'div-show' : 'div-hide'"
      >
        <div class="vx-row mb-4 mt-4">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Número Carteira"
              name="Número Carteira"
              id="Número Carteira"
              v-model="formCadastro.numeroCarteira"
              v-validate="{ required: true }"
              :state="validateState('Número Carteira')"
              :class="validateClass('Número Carteira')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="verificaExibicao('NumeroConvenio')">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Número Convênio"
              name="Número Convênio"
              id="Número Convênio"
              v-model="formCadastro.dadosArquivoRemessa.NumeroConvenio"
              v-validate="{ required: true }"
              :state="validateState('Número Convênio')"
              :class="validateClass('Número Convênio')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="verificaExibicao('carteira')">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Carteira"
              name="Carteira"
              id="Carteira"
              v-model="formCadastro.dadosArquivoRemessa.carteira"
              v-validate="{ required: true }"
              :state="validateState('Carteira')"
              :class="validateClass('Carteira')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="verificaExibicao('primeiraInstrucao')">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Primeira Instrução"
              name="Primeira Instrução"
              id="Primeira Instrução"
              v-model="formCadastro.dadosArquivoRemessa.primeiraInstrucao"
              v-validate="{ required: true }"
              :state="validateState('Primeira Instrução')"
              :class="validateClass('Primeira Instrução')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="verificaExibicao('segundaInstrucao')">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Segunda Instrução"
              name="Segunda Instrução"
              id="Segunda Instrução"
              v-model="formCadastro.dadosArquivoRemessa.segundaInstrucao"
              v-validate="{ required: true }"
              :state="validateState('Segunda Instrução')"
              :class="validateClass('Segunda Instrução')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!formCadastro.isGalaxyPay"
        :class="passo == 2 ? 'div-show' : 'div-hide'"
      >
        <vs-alert
          color="primary"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
        >
          O Beneficiário é a pessoa que detém a conta bancária e que receberá o
          dinheiro dos boletos pagos
        </vs-alert>
        <div class="vx-row">
          <div class="vx-col mb-6">
            <span>Utilizar os mesmos dados da Empresa?</span>
            <vs-switch
              color="success"
              v-model="formCadastro.dadosBeneficiario.usarDadosEmpresa"
              style="width: 60px"
              @input="selecionaDadosEmpresa()"
            >
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full mb-3">
            <vs-select
              v-model="formCadastro.dadosBeneficiario.tipo"
              label="Tipo"
              class="select-large w-full"
              name="Tipo"
              v-validate="{ required: true }"
              :state="validateState('Tipo')"
              :class="validateClass('Tipo')"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.label"
                v-for="(item, index) in tiposPessoas"
              />
            </vs-select>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              v-if="formCadastro.dadosBeneficiario.tipo == 'PJ'"
              size="large"
              class="w-full"
              label-placeholder="Razão Social"
              name="Razão Social"
              id="Razão Social"
              v-model="formCadastro.dadosBeneficiario.nome"
              v-validate="{ required: true, min: 6 }"
              :state="validateState('Razão Social')"
              :class="validateClass('Razão Social')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
            <vs-input
              v-else
              size="large"
              class="w-full"
              label-placeholder="Nome Completo"
              name="Nome Completo"
              id="Nome Completo"
              v-model="formCadastro.dadosBeneficiario.nome"
              v-validate="{ required: true, min: 6 }"
              :state="validateState('Nome Completo')"
              :class="validateClass('Nome Completo')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              v-if="formCadastro.dadosBeneficiario.tipo == 'PJ'"
              size="large"
              class="w-full"
              label-placeholder="CNPJ"
              name="CNPJ"
              id="CNPJ"
              v-model="formCadastro.dadosBeneficiario.cpfcnpj"
              v-validate="{ required: true, min: 18 }"
              :state="validateState('CNPJ')"
              :class="validateClass('CNPJ')"
              v-mask="'##.###.###/####-##'"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
            <vs-input
              v-else
              size="large"
              class="w-full"
              label-placeholder="CPF"
              name="CPF"
              id="CPF"
              v-model="formCadastro.dadosBeneficiario.cpfcnpj"
              v-validate="{ required: true, min: 14 }"
              :state="validateState('CPF')"
              :class="validateClass('CPF')"
              v-mask="'###.###.###-##'"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Endereço"
              name="Endereço"
              id="Endereço"
              v-model="formCadastro.dadosBeneficiario.endereco"
              v-validate="{ required: true, min: 6 }"
              :state="validateState('Endereço')"
              :class="validateClass('Endereço')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Numero"
              name="Numero"
              id="Numero"
              v-model="formCadastro.dadosBeneficiario.numero"
              :state="validateState('Numero')"
              :class="validateClass('Numero')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="bairro"
              name="bairro"
              id="bairro"
              v-model="formCadastro.dadosBeneficiario.bairro"
              v-validate="{ required: true }"
              :state="validateState('bairro')"
              :class="validateClass('bairro')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Cidade"
              name="Cidade"
              id="Cidade"
              v-model="formCadastro.dadosBeneficiario.cidade"
              v-validate="{ required: true, min: 6 }"
              :state="validateState('Cidade')"
              :class="validateClass('Cidade')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Estado"
              name="Estado"
              id="Estado"
              v-model="formCadastro.dadosBeneficiario.estado"
              :state="validateState('Estado')"
              :class="validateClass('Estado')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Cep"
              name="Cep"
              id="Cep"
              v-model="formCadastro.dadosBeneficiario.cep"
              v-validate="{ required: true }"
              :state="validateState('Cep')"
              :class="validateClass('Cep')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>
      </div>
      <div
        v-if="!formCadastro.isGalaxyPay"
        :class="passo == 3 ? 'div-show' : 'div-hide'"
      >
        <vs-alert
          color="primary"
          title="Defina o Nosso Número do próximo boleto que será gerado!!"
          active="true"
          class="my-3"
          style="height: auto !important"
        >
          O Nosso número é um número atribuído a cada boleto que serve para
          identificar o pagamento quando o dinheiro entrar na conta.<br />
          Esse número deve ser único por boleto bancário gerado para essa
          carteira
        </vs-alert>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full mb-3">
            <vs-select
              v-model="formCadastro.carteiraJaEmitiuBoletos"
              label="Essa Carteira já foi utilizada para emitir boletos?"
              class="select-large w-full"
              name="Carteira já Emitiu Boletos"
              v-validate="{ required: true }"
              :state="validateState('Carteira já Emitiu Boletos')"
              :class="validateClass('Carteira já Emitiu Boletos')"
            >
              <vs-select-item
                :key="index"
                :value="item.id"
                :text="item.label"
                v-for="(item, index) in utlizacaoBoletos"
              />
            </vs-select>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Próximo Nosso Número"
              name="Próximo Nosso Número"
              id="Próximo Nosso Número"
              type="number"
              :disabled="
                formCadastro.carteiraJaEmitiuBoletos == true ? false : true
              "
              v-model="formCadastro.proximoNossoNumero"
              v-validate="{ required: true, min_value: 1 }"
              :state="validateState('Próximo Nosso Número')"
              :class="validateClass('Próximo Nosso Número')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
          </div>
        </div>
      </div>

      <div
        v-if="!formCadastro.isGalaxyPay"
        :class="passo == 4 ? 'div-show' : 'div-hide'"
      >
        <div class="vx-row mb-4">
          <div class="vx-col w-1/2">
            <label for="" class="vs-select--label">Multa %</label>
            <money
              class="w-full vs-inputx vs-input--input large"
              name="Multa"
              id="Multa"
              v-model="formCadastro.percentualMulta"
              v-validate="{ required: true }"
              :state="validateState('Multa')"
              :danger="validateClass('Multa')"
              v-bind="money"
            ></money>
            <small>
              % de multa que será aplicado ao valor do boleto em caso de atraso
              do pagamento
            </small>
          </div>
          <div class="vx-col w-1/2">
            <label for="" class="vs-select--label">Juros (diario)</label>
            <money
              class="w-full vs-inputx vs-input--input large"
              name="Juros"
              id="Juros"
              v-model="formCadastro.percentualJurosDiario"
              v-validate="{ required: true }"
              :state="validateState('Juros')"
              :danger="validateClass('Juros')"
              v-bind="money"
            ></money>
            <small>
              % diário de juros que será aplicado ao valor do boleto em caso de
              atraso
            </small>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-1/2">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Aplicar juros a partir de quantos dias"
              name="Aplicar juros a partir de quantos dias"
              id="Aplicar juros a partir de quantos dias"
              type="number"
              v-model="formCadastro.diasJuros"
              :state="validateState('Aplicar juros a partir de quantos dias')"
              :class="validateClass('Aplicar juros a partir de quantos dias')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
            <small>Informe 0 (zero) para não cobrar juros</small>
          </div>
          <div class="vx-col sm:w-1/1 w-1/2">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Dias para Protesto"
              name="Dias para Protesto"
              id="Dias para Protesto"
              type="number"
              v-model="formCadastro.diasProtesto"
              :state="validateState('Dias para Protesto')"
              :class="validateClass('Dias para Protesto')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
            <small>Informe 0 (zero) para não protestar</small>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-1/2">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Dias p/ expiração da 1ª parcela"
              name="Dias p/ expiração da 1ª parcela"
              id="Dias p/ expiração da 1ª parcela"
              type="number"
              min="0"
              v-model.number="formCadastro.diasExpiracaoPrimeiraParcela"
              :state="validateState('Dias p/ expiração da 1ª parcela')"
              :class="validateClass('Dias p/ expiração da 1ª parcela')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
            <small>
              Quantidade de dias para pagamento após vencimento. Informe 0
              (zero) para não ser pagável após vencimento
            </small>
          </div>
          <div class="vx-col sm:w-1/1 w-1/2">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Dias p/ expiração das demais parcelas"
              name="Dias p/ expiração das demais parcelas"
              id="Dias p/ expiração das demais parcelas"
              type="number"
              min="0"
              v-model.number="formCadastro.diasExpiracaoParcelas"
              :state="validateState('Dias p/ expiração das demais parcelas')"
              :class="validateClass('Dias p/ expiração das demais parcelas')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
            <small>
              Quantidade de dias para pagamento após vencimento. Informe 0
              (zero) para não ser pagável após vencimento
            </small>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Dias p/ expiração de parcelas de boleto avulso"
              name="Dias p/ expiração de parcelas de boleto avulso"
              id="Dias p/ expiração de parcelas de boleto avulso"
              type="number"
              min="0"
              v-model.number="formCadastro.diasExpiracaoAvulsos"
              :state="
                validateState('Dias p/ expiração de parcelas de boleto avulso')
              "
              :class="
                validateClass('Dias p/ expiração de parcelas de boleto avulso')
              "
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
            <small>
              Quantidade de dias para pagamento após vencimento. Informe 0
              (zero) para não ser pagável após vencimento
            </small>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Dias entre datas de vencimento de parcelas de boleto prêmio"
              name="Dias entre datas de vencimento de parcelas de boleto prêmio"
              id="Dias entre datas de vencimento de parcelas de boleto prêmio"
              type="number"
              v-model.number="formCadastro.minimalDaysBetweenDueDates"
              :state="
                validateState(
                  'Dias entre datas de vencimento de parcelas de boleto prêmio',
                )
              "
              :class="
                validateClass(
                  'Dias entre datas de vencimento de parcelas de boleto prêmio',
                )
              "
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
            <small>
              Quantidade mínima de dias entre o vencimento dois boletos de uma
              apólice
            </small>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/2 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Dias de vencimento para ignorar gateway"
              name="Dias de vencimento para ignorar gateway"
              id="Dias de vencimento para ignorar gateway"
              type="number"
              v-model.number="formCadastro.expiredBilletDaysToIgnoreGateway"
              :danger="
                formCadastro.expiredBilletDaysToIgnoreGateway !== '' &&
                formCadastro.expiredBilletDaysToIgnoreGateway !== null &&
                formCadastro.expiredBilletDaysToIgnoreGateway < 1
              "
              danger-text="O valor deve ser maior ou igual a 1 (ou deixe vazio para desativar)"
              val-icon-danger="clear"
            />
            <small>
              Boletos vencidos há igual ou mais dias que este valor serão
              cancelados/liquidados/excluídos apenas no BP Seg, sem envio ao
              banco. Deixe em branco para desativar.
            </small>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-textarea
              label="Instruções para o caixa"
              v-model="formCadastro.instrucaoCaixa"
              id="instrucaoCaixa"
              height="120"
            />
            <vs-row class="mb-4" vs-type="flex" vs-justify="space-between">
              <vs-button @click.prevent="insertCode('[LIMITE_DIAS_PAGAMENTO]')">
                Dias para expiração
              </vs-button>
              <vs-button @click.prevent="insertCode('[MULTA_PERCENTUAL]')">
                Multa %
              </vs-button>
              <vs-button @click.prevent="insertCode('[JUROS_PERCENTUAL]')">
                Juros (diário)
              </vs-button>
              <vs-button @click.prevent="insertCode('[DIAS_APLICAR_JUROS]')">
                Dias para aplicar juros
              </vs-button>
            </vs-row>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full mb-24">
            <div class="mb-2">
              <label for="" class="vs-select--label">Intrução Inicial</label>
            </div>
            <quill-editor
              class="h-full"
              v-model="formCadastro.instrucaoInicial"
            ></quill-editor>
          </div>
        </div>
      </div>
      <div
        v-if="formCadastro.isGalaxyPay"
        :class="passo == 5 ? 'div-show' : 'div-hide'"
      >
        <div class="vx-row">
          <div class="vx-col mb-4 mt-4">
            <span>Sandbox</span>
            <vs-switch
              color="success"
              v-model="formCadastro.dadosGalaxy.sandBox"
              style="width: 60px"
            >
              <span slot="on">Sim</span>
              <span slot="off">Não</span>
            </vs-switch>
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Galax ID"
              name="Galax ID"
              id="Galax ID"
              type="number"
              v-model="formCadastro.dadosGalaxy.id"
              :state="validateState('Galax ID')"
              :class="validateClass('Galax ID')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              v-validate="{ required: true }"
            />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Galax Hash"
              name="Galax Hash"
              id="Galax Hash"
              v-model="formCadastro.dadosGalaxy.hash"
              :state="validateState('Galax Hash')"
              :class="validateClass('Galax Hash')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              v-validate="{ required: true }"
            />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="formCadastro.dadosGalaxy.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Galax ID (SandBox)"
              name="Galax ID (SandBox)"
              id="Galax ID (SandBox)"
              type="number"
              v-model="formCadastro.dadosGalaxy.idSandBox"
              :state="validateState('Galax ID')"
              :class="validateClass('Galax ID')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              v-validate="{ required: true }"
            />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="formCadastro.dadosGalaxy.sandBox">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Galax Hash (SandBox)"
              name="Galax Hash (SandBox)"
              id="Galax Hash (SandBox)"
              v-model="formCadastro.dadosGalaxy.hashSandBox"
              :state="validateState('Galax Hash (SandBox)')"
              :class="validateClass('Galax Hash (SandBox)')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
              v-validate="{ required: true }"
            />
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label for="" class="vs-select--label">Multa %</label>

            <money
              class="w-full vs-inputx vs-input--input large"
              name="Multa"
              id="Multa"
              v-model="formCadastro.dadosGalaxy.percentualMulta"
              v-validate="{ required: true }"
              :state="validateState('Multa')"
              :danger="validateClass('Multa')"
              v-bind="money"
            ></money>
            <small
              >O Percentual de multa que será aplicado ao valor do boleto em
              caso de atraso do pagamento</small
            >
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label for="" class="vs-select--label">Juros (diario)</label>

            <money
              class="w-full vs-inputx vs-input--input large"
              name="Juros"
              id="Juros"
              v-model="formCadastro.dadosGalaxy.percentualJurosDiario"
              v-validate="{ required: true }"
              :state="validateState('Juros')"
              :danger="validateClass('Juros')"
              v-bind="money"
            ></money>
            <small
              >O Percentual diário de juros que será aplicado ao valor do boleto
              em caso de atraso</small
            >
          </div>
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col sm:w-1/1 w-full">
            <vs-input
              size="large"
              class="w-full"
              label-placeholder="Dias para Protesto"
              name="Dias para Protesto"
              id="Dias para Protesto"
              type="number"
              v-model="formCadastro.dadosGalaxy.diasProtestoGalax"
              :state="validateState('Dias para Protesto')"
              :class="validateClass('Dias para Protesto')"
              val-icon-danger="clear"
              danger-text="Preencha este Campo"
            />
            <small>Informe 0 (zero) para não protestar</small>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full mb-2">
            <vs-textarea
              label="Instruções para o caixa"
              v-model="formCadastro.dadosGalaxy.instrucaoCaixa"
              id="instrucaoCaixa"
            />
            <div>
              <vs-button
                type="button"
                @click.prevent="insertCode('[LIMITE_DIAS_PAGAMENTO]')"
              >
                Limite Dias Pagamento
              </vs-button>
              <vs-button
                type="button"
                @click.prevent="insertCode('[MULTA_PERCENTUAL]')"
              >
                Percentual de Multa
              </vs-button>
              <vs-button
                type="button"
                @click.prevent="insertCode('[JUROS_PERCENTUAL]')"
              >
                Percentual de Juros
              </vs-button>
              <vs-button
                type="button"
                @click.prevent="insertCode('[DIAS_APLICAR_JUROS]')"
              >
                Dias para aplicar juros
              </vs-button>
            </div>
          </div>
        </div>
      </div>
      <div :class="passo == 6 ? 'div-show' : 'div-hide'">
        <div class="vx-row">
          <div class="vx-col sm:w-1/1 w-full mb-3">
            <vs-select
              multiple
              v-model="formCadastro.formasPagamento"
              label="Formas de Pagamento utilizadas nessa Carteira"
              class="select-large w-full"
              name="Formas de Pagamento utilizadas nessa Carteira"
              v-validate="{ required: true }"
              :state="
                validateState('Formas de Pagamento utilizadas nessa Carteira')
              "
              :class="
                validateClass('Formas de Pagamento utilizadas nessa Carteira')
              "
            >
              <vs-select-item
                :key="index"
                :value="item.id_tipoPagamentoEmpresa"
                :text="item.nomePagamento"
                v-for="(item, index) in formasPagamento"
              />
            </vs-select>
          </div>
        </div>
      </div>
      <!--vs-tabs v-model="passo">
        <vs-tab label="Dados Gerais"> </vs-tab>
        <vs-tab label="Dados de Remessa"> </vs-tab>
        <vs-tab label="Dados do Beneficiário"> </vs-tab>
        <vs-tab label="Dados do Nosso Número"> </vs-tab>
        <vs-tab label="Dados do Boleto"> </vs-tab>
      </vs-tabs-->
      <div class="vx-row">
        <div class="vx-col w-full text-right mt-5">
          <vs-button
            color="warning"
            type="border"
            class="mr-3 mb-2"
            @click.stop.prevent="onReset"
            >Cancelar</vs-button
          >

          <BotaoSubmit
            variant="success"
            :edit="true"
            :aguarde="aguardeCadastro"
            reference="BtnEditar"
          ></BotaoSubmit>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import locale from './../../locale';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import service from '../../services';
import BotaoSubmit from './../../components/BotaoSubmit';
import jwt from 'jsonwebtoken';
import vSelect from 'vue-select';
import { Money } from 'v-money';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { quillEditor } from 'vue-quill-editor';

export default {
  props: ['dados'],
  watch: {
    passo: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.$validator.validateAll();
      }
    },
    dados(value) {
      this.preencheForm();
    },
  },
  data() {
    return {
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      blockName: false,
      passo: 0,
      contas: [],
      formasPagamento: [],
      aguardeCadastro: false,
      dadosEmpresa: null,
      tiposPessoas: [
        { label: 'Selecione', id: null },
        { label: 'Pessoa Física', id: 'PF' },
        { label: 'Pessoa Jurídica', id: 'PJ' },
      ],
      utlizacaoBoletos: [
        { label: 'Selecione', id: null },
        { label: 'Primeira Vez', id: false },
        { label: 'Já Emiti Boletos', id: true },
      ],
      dadosBanco: {
        camposObrigatoriosRemessa: '',
      },
      formCadastro: {
        isGalaxyPay: false,
        idEmpresa: null,
        idConta: null,
        nomeCarteira: '',
        dadosArquivoRemessa: {},
        dadosBeneficiario: {},
        proximoNossoNumero: 1,
        numeroCarteira: null,
        dadosGalaxy: {},
        formasPagamento: [],
        diasProtesto: 1,
        diasJuros: 1,
        diasExpiracaoPrimeiraParcela: 0,
        diasExpiracaoParcelas: 0,
        diasExpiracaoAvulsos: 0,
        instrucaoCaixa: '',
        instrucaoInicial: null,
        minimalDaysBetweenDueDates: 0,
        expiredBilletDaysToIgnoreGateway: null,
      },
    };
  },
  methods: {
    insertCode(code) {
      const textarea = document.getElementById('instrucaoCaixa');
      const cursorPos = textarea.selectionStart;
      const v = this.formCadastro.instrucaoCaixa;
      const textBefore = v.substring(0, cursorPos);
      const textAfter = v.substring(cursorPos, v.length);

      this.formCadastro.instrucaoCaixa = textBefore + code + textAfter;

      this.$nextTick(() => {
        textarea.selectionStart = cursorPos + code.length;
        textarea.selectionEnd = cursorPos + code.length;
        textarea.focus();
      });
    },
    preencheForm() {
      if (this.dados.idCarteira) {
        //this.$validator.clean();
        this.$validator.pause();
        this.$nextTick(() => {
          this.$validator.errors.clear();
          this.$validator.fields.items.forEach((field) => field.reset());
          this.$validator.fields.items.forEach((field) =>
            this.errors.remove(field),
          );
          this.$validator.resume();
        });
        this.formCadastro.isGalaxyPay = this.dados.isGalaxyPay;
        this.formCadastro.idCarteira = this.dados.idCarteira;
        this.formCadastro.idConta = this.dados.idConta;
        this.formCadastro.status = this.dados.deletedAt == null ? true : false;
        this.formCadastro.nomeCarteira = this.dados.nomeCarteira;
        this.formCadastro.dadosArquivoRemessa = this.dados.dadosArquivoRemessa;
        this.formCadastro.dadosBeneficiario = this.dados.dadosBeneficiario;
        this.formCadastro.dadosGalaxy = this.dados.dadosGalaxy;
        this.formCadastro.proximoNossoNumero = this.dados.proximoNossoNumero;
        this.formCadastro.percentualMulta = this.dados.percentualMulta;
        this.formCadastro.percentualJurosDiario =
          this.dados.percentualJurosDiario;
        this.formCadastro.numeroCarteira = this.dados.numeroCarteira;
        this.formCadastro.carteiraJaEmitiuBoletos =
          this.dados.carteiraJaEmitiuBoletos;
        this.formCadastro.diasProtesto = this.dados.diasProtesto;
        this.formCadastro.diasJuros = this.dados.diasJuros;
        this.formCadastro.diasExpiracaoPrimeiraParcela =
          this.dados.diasExpiracaoPrimeiraParcela;
        this.formCadastro.diasExpiracaoParcelas =
          this.dados.diasExpiracaoParcelas;
        this.formCadastro.diasExpiracaoAvulsos =
          this.dados.diasExpiracaoAvulsos;
        this.formCadastro.instrucaoCaixa = this.dados.instrucaoCaixa;
        this.formCadastro.instrucaoInicial = this.dados.instrucaoInicial;
        this.formCadastro.minimalDaysBetweenDueDates =
          this.dados.minimalDaysBetweenDueDates;
        this.formCadastro.expiredBilletDaysToIgnoreGateway =
          this.dados.expiredBilletDaysToIgnoreGateway || null;
        this.selecionaConta();
      } else {
        this.resetForm();
      }
      this.buscaFormasPagamentoDisponiveis();
    },
    selecionaDadosEmpresa() {
      if (this.formCadastro.dadosBeneficiario.usarDadosEmpresa) {
        if (this.dadosEmpresa[0].cnpj.length > 14)
          this.formCadastro.dadosBeneficiario.tipo = 'PJ';
        else this.formCadastro.dadosBeneficiario.tipo = 'PF';

        this.formCadastro.dadosBeneficiario.nome =
          this.dadosEmpresa[0].razaoSocial;
        this.formCadastro.dadosBeneficiario.cpfcnpj = this.dadosEmpresa[0].cnpj;
        this.formCadastro.dadosBeneficiario.endereco =
          this.dadosEmpresa[0].endereco;
        this.formCadastro.dadosBeneficiario.numero =
          this.dadosEmpresa[0].numero;
        this.formCadastro.dadosBeneficiario.bairro =
          this.dadosEmpresa[0].bairro;
        this.formCadastro.dadosBeneficiario.cidade =
          this.dadosEmpresa[0].cidade;
        this.formCadastro.dadosBeneficiario.estado =
          this.dadosEmpresa[0].estado;
        this.formCadastro.dadosBeneficiario.cep = this.dadosEmpresa[0].cep;
      }
    },
    verificaExibicao(tipo) {
      return this.dadosBanco.camposObrigatoriosRemessa.indexOf(tipo) >= 0;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref) ? 'has-error' : '';
      }
      return null;
    },
    validateStyle(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return {
          border: '1px solid red !important',
          borderRadius: '5px',
        };
      }
      return null;
    },
    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    selecionaIsGalaxyPay() {
      if (this.formCadastro.isGalaxyPay == true) {
        this.formCadastro.nomeCarteira = 'Galax Pay';
        this.blockName = true;
      } else {
        this.blockName = false;
        this.formCadastro.dadosGalaxy = {};
      }
    },
    selecionaConta() {
      if (this.formCadastro.idConta) {
        this.$vs.loading();
        service
          .post('CarteiraCobranca', 'buscaDadosBanco', this.formCadastro)
          .then((res) => {
            this.aguardeCadastro = false;
            this.dadosBanco = res.data;
            this.$vs.loading.close();
          })
          .catch((error) => {
            this.aguardeCadastro = false;
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não foi possível buscar Dados',
              color: 'danger',
            });
          });
      }
    },
    buscaFormasPagamentoDisponiveis() {
      if (localStorage.getItem('user-token')) {
        try {
          this.$vs.loading();
          const decoded = jwt.decode(localStorage.getItem('user-token'));
          this.formCadastro.idEmpresa = decoded.id_empresa;

          service
            .post(
              'CarteiraCobranca',
              'buscaFormasPagamentoDisponiveis',
              this.formCadastro,
            )
            .then((res) => {
              this.formasPagamento = res.data;
              this.formCadastro.formasPagamento = [];
              this.formasPagamento.forEach((element) => {
                if (element.selecionado == 1) {
                  this.formCadastro.formasPagamento.push(
                    element.id_tipoPagamentoEmpresa,
                  );
                }
              });
              //this.carregando = false;
              this.$vs.loading.close();
            })
            .catch((e) => {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: e,
                color: 'danger',
              });
              this.$vs.loading.close();
            });
        } catch (error) {}
      }
    },
    buscaDadosCadastroEmpresa() {
      if (localStorage.getItem('user-token')) {
        try {
          this.$vs.loading();
          const decoded = jwt.decode(localStorage.getItem('user-token'));
          this.formCadastro.idEmpresa = decoded.id_empresa;

          service
            .getAll(
              'g',
              {},
              'empresas/list/idEmpresa/' + this.formCadastro.idEmpresa,
            )
            .then((res) => {
              this.dadosEmpresa = res.data;
              //this.carregando = false;
              this.$vs.loading.close();
            })
            .catch((e) => {
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: e,
                color: 'danger',
              });
              this.$vs.loading.close();
            });
        } catch (error) {}
      }
    },

    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;

      var action = 'Atualizar';
      var msgRetorno = 'Dados Atualizados com sucesso';
      if (!this.formCadastro.idCarteira) {
        action = 'Adicionar';
        msgRetorno = `Registro Adicionado com sucesso`;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          this.aguardeCadastro = true;
          service
            .post('CarteiraCobranca', action, this.formCadastro)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$emit('concluido');
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: msgRetorno,
                color: 'success',
              });
            })
            .catch((error) => {
              this.$vs.loading.close();
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },
    resetForm() {
      this.formCadastro = {
        isGalaxyPay: false,
        idConta: null,
        nomeCarteira: '',
        dadosArquivoRemessa: {},
        dadosBeneficiario: {},
        dadosGalaxy: {},
        proximoNossoNumero: null,
        percentualMulta: null,
        percentualJurosDiario: null,
        numeroCarteira: '',
        carteiraJaEmitiuBoletos: null,
        diasProtesto: '',
        instrucaoCaixa: '',
        dadosGalaxy: {},
        formasPagamento: [],
        diasProtesto: 1,
        diasJuros: 1,
        instrucaoInicial: null,
        expiredBilletDaysToIgnoreGateway: null,
      };
      this.$nextTick(() => {
        this.show = true;
      });
    },
    onReset(evt) {
      evt.preventDefault();
      this.resetForm();
    },
  },
  created() {
    this.$validator.localize('ptBr', locale);
  },
  mounted() {
    this.buscaDadosCadastroEmpresa();
    //this.buscaFormasPagamentoDisponiveis();

    this.buscaDadosSelectsPorEmpresa(
      'empresasContasBancarias',
      'contas',
      'nomeConta',
      'idConta',
    );
  },
  components: {
    BotaoSubmit,
    vSelect,
    Money,
    quillEditor,
  },
};
</script>
<style scoped>
.div-show {
  display: 'block';
}
.div-hide {
  display: none;
}

li.activeChild {
  border-bottom: 1px solid rgba(var(--vs-primary), 1) !important;
}
</style>
